<template>
  <div>
    <PesquisaPacienteModal
        v-if="modalSelecionarPaciente"
        v-model="modalSelecionarPaciente"
        @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
        @confirmarPacienteSelecionado="selecionarPaciente"
    />
    <cobranca-cadastro-modal
        v-if="modalAdicionarCobranca"
        v-model="modalAdicionarCobranca"
        :paciente-id="idPaciente"
        @fecharModalCadastro="fecharModalCadastroCobranca"
    />
    <cobranca-edicao-modal
        v-if="modalEditarCobranca"
        v-model="modalEditarCobranca"
        :id-cobranca="idCobranca"
        exibir-paciente
        @fecharModalEdicao="fecharModalEdicaoCobranca"
    />
    <GerarRelatorioCobrancas
        v-if="modalRelatorioCobrancas"
        v-model="modalRelatorioCobrancas"
        :pacientePreSelecionado="pacienteSelecionado"
        permitir-selecionar-paciente
        @fecharModalRelatorio="fecharModalRelatorioCobrancas"
    />
    <toolbar-view>
      <botao-acao slot="actions" hideBorder @click="abrirModalSelecionarPaciente">
        <v-icon>mdi-magnify</v-icon>
        Selecionar Paciente
      </botao-acao>
      <botao-acao slot="actions-second" hideBorder @click="abrirModalRelatorioCobrancas" v-if="podeGerarRelatorioCobrancas">
        <v-icon>mdi-file-document</v-icon>
        Gerar relatório
      </botao-acao>
      <v-flex slot="simpleSearch">
        <pesquisa-avancada
            :filter="filtrosInterno"
            :buscaAvancada="true"
            @remove-filter="tratarEventoRemoverFiltro"
            @simple-search="tratarEventoBuscaSimples"
            @advanced-search="tratarEventoBuscaAvancada"
            @clear="tratarEventoLimparBuscaAvancada"
            :maxlengthInput="maxInputPesquisa"
            simple-search-placeholder="Busque por: Código ou nome do paciente...">
          <item-de-pesquisa slot="search-items">
            <v-select
                v-model="filtrosInterno.atributo.value"
                label="Filtrar por"
                :items="filtrosInterno.atributo.data"
                dense/>
            <v-select
                v-model="filtrosInterno.tipo.value"
                label="Tipo de busca"
                :items="filtrosInterno.tipo.data"
                dense/>
            <v-text-field
                v-model="filtrosInterno.conteudo.value"
                label="Conteúdo da busca"
                :maxlength="maxInputPesquisa"
                placeholder="Pesquise aqui..."
                @keyup.enter="tratarEventoBuscaAvancada"/>
            <v-select
                v-model="filtrosInterno.statusCobranca.value"
                label="Selecionar o status"
                :items="filtrosInterno.statusCobranca.data"
                item-text="nome"
                item-value="valor"
            />
            <v-select
                v-model="filtrosInterno.tipoPeriodo.value"
                label="Selecionar tipo período"
                :items="filtrosInterno.tipoPeriodo.data"
                item-text="nome"
                item-value="valor"
            />
            <date-input
                v-model="filtrosInterno.dataInicio.value"
                label="Data Início"
                name-date="dataInicio"
                placeholderDate="Informe a data de início"
            />
            <date-input
                v-model="filtrosInterno.dataFim.value"
                label="Data Fim"
                name-date="dataFim"
                placeholderDate="Informe a data final"
            />
          </item-de-pesquisa>
        </pesquisa-avancada>
      </v-flex>
    </toolbar-view>
    <div v-if="pacienteSelecionado" class="cardPaciente">
      <div class="container-opcoes-paciente">
        <div class="container-btn-opcoes-paciente">
          <botao-acao-tooltip @click="abrirModalCadastroCobranca" mensagem-tooltip="Cadastrar uma cobrança para este paciente.">
            <v-icon color="#fff">mdi-cash</v-icon>
            Adicionar cobrança
          </botao-acao-tooltip>
          <botao-acao-tooltip @click="acessarFichaPaciente" mensagem-tooltip="Acessar ficha do paciente." class="ml-3">
            <v-icon color="#fff">mdi-account-box</v-icon>
            Ficha
          </botao-acao-tooltip>
        </div>
        <v-btn class="close__button" text @click="removerPacienteSelecionado" icon>
          <v-icon color="#fff">close</v-icon>
        </v-btn>
      </div>
      <div class="atributos-paciente">
      <div class="selecionado-label">
        <span style="font-size: 14px">Nome</span>
        <p>{{ pacienteSelecionado.nome }}</p>
      </div>
      <div class="selecionado-label" style="margin-top: 5px">
        <span style="font-size: 14px">CPF/CNPJ</span>
        <p>{{ pacienteSelecionado.cnpjCpf | formatarCpfCnpj }}</p>
      </div>
      </div>
    </div>
    <cobranca-listagem-tabela
        :itens="itens"
        :paginas="paginas"
        :total-itens="totalItens"
        :paginacao="$store.state.cobranca.resultadoBuscaTodasCobrancas.paginacao"
        @acessar="tratarEventoAcessarCobranca"
        @paginar="tratarEventoPaginar"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import VerificarPerfilUsuario from '@/core/utils/VerificarPerfilUsuario'
import CobrancaListagemTabela from '@/views/pages/cadastros/cobranca/CobrancaListagemTabela.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import CobrancaEdicaoModal from '@/views/modais/CobrancaEdicaoModal.vue'
import CobrancaCadastroModal from '@/views/modais/CobrancaCadastroModal.vue'
import BotaoAcaoTooltip from '@/views/components/BotaoAcaoTooltip.vue'
import GerarRelatorioCobrancas from '@/views/modais/GerarRelatorioCobrancas.vue'
import ItemDePesquisa from '@/views/components/ItemDePesquisa.vue'
import PesquisaAvancada from '@/views/components/PesquisaAvancada.vue'
import DateInput from '@/views/components/DateInput.vue'

export default {
    name: 'CobrancaListagem',
    components: {
        DateInput,
        PesquisaAvancada, ItemDePesquisa,
        GerarRelatorioCobrancas,
        BotaoAcaoTooltip,
        CobrancaCadastroModal,
        CobrancaEdicaoModal,
        PesquisaPacienteModal, CobrancaListagemTabela
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            idPaciente: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            maxInputPesquisa: 30,
            pacienteSelecionado: null,
            orcamentoModal: false,
            modalAdicionarCobranca: false,
            modalEditarCobranca: false,
            modalSelecionarPaciente: false,
            modalRelatorioCobrancas: false,
            idCobranca: null,
            podeGerarRelatorioCobrancas: false,
        }
    },
    mounted() {
        this.verificarPermissoesRelatorio()
    },
    methods: {
        ...mapMutations([
            mutationTypes.COBRANCA.SET_FILTROS_BUSCA_TODAS_COBRANCAS,
            mutationTypes.COBRANCA.SET_PAGINACAO_BUSCA_TODAS_COBRANCAS,
            mutationTypes.COBRANCA.RESETA_PAGE
        ]),
        verificarPermissoesRelatorio(){
            if(VerificarPerfilUsuario(['ADMINISTRADOR', 'RELATORIO_COBRANCA'])){
                this.podeGerarRelatorioCobrancas = true
            }
        },
        async buscar() {
            this.setFiltrosBuscaTodasCobrancas(this.getFiltrosInterno())
            await this.buscarCobrancas()
        },
        async buscarCobrancas() {
            const resposta = await this.$store.dispatch(actionTypes.COBRANCA.BUSCAR_TODAS_COBRANCAS, this.idPaciente)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.cobranca.resultadoBuscaTodasCobrancas.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.setPaginacaoBuscaTodasCobrancas(paginacao)
            this.buscar()
        },
        tratarEventoAcessarCobranca(item) {
            const id = item.id
            this.idCobranca = id
            this.modalEditarCobranca = true
        },
        fecharModalEdicaoCobranca() {
            this.modalEditarCobranca = false
            this.idCobranca = null
            this.buscar()
        },
        tratarEventoBuscaSimples(busca) {
            this.resetaPage()
            this.filtrosInterno.tipo.value = busca.tipo
            this.filtrosInterno.atributo.value = busca.atributo
            this.filtrosInterno.conteudo.value = busca.conteudo
            this.buscar()
        },
        acessarFichaPaciente(){
            this.$router.push({name: 'PacienteFicha', params: { id: this.idPaciente }})
        },
        abrirModalCadastroCobranca() {
            this.modalAdicionarCobranca = true
        },
        fecharModalCadastroCobranca() {
            this.modalAdicionarCobranca = false
            this.buscar()
        },
        abrirModalSelecionarPaciente(){
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente(){
            this.modalSelecionarPaciente = false
        },
        selecionarPaciente(paciente){
            this.fecharModalSelecionarPaciente()
            this.pacienteSelecionado = paciente
            this.idPaciente = paciente.id
            this.resetaPage()
            this.buscar()
        },
        removerPacienteSelecionado(){
            this.pacienteSelecionado = null
            this.idPaciente = null
            this.resetaPage()
            this.buscar()
        },
        abrirModalRelatorioCobrancas(){
            this.modalRelatorioCobrancas = true
        },
        fecharModalRelatorioCobrancas(){
            this.modalRelatorioCobrancas = false
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno[propriedade]) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.buscar()
        },
        tratarEventoBuscaAvancada() {
            if((this.filtrosInterno.tipo.value || this.filtrosInterno.atributo.value) && !this.filtrosInterno.conteudo.value){
                this.mostrarNotificacaoErro('Informe o conteúdo da busca!')
                return
            }
            this.resetaPage()
            this.buscar()
        },
        tratarEventoLimparBuscaAvancada() {
            this.filtrosInterno.tipo.value = this.filtrosInterno.tipo.default
            this.filtrosInterno.atributo.value = this.filtrosInterno.atributo.default
            this.filtrosInterno.conteudo.value = this.filtrosInterno.conteudo.default
            this.filtrosInterno.statusCobranca.value = this.filtrosInterno.statusCobranca.default
            this.filtrosInterno.tipoPeriodo.value = this.filtrosInterno.tipoPeriodo.default
            this.filtrosInterno.dataInicio.value = this.filtrosInterno.dataInicio.default
            this.filtrosInterno.dataFim.value = this.filtrosInterno.dataFim.default
            this.buscar()
        },
    }
}
</script>

<style scoped lang="stylus">

.atributos-paciente
  height 150px
  width 100%
  display flex
  flex-direction column
  justify-content center
  align-items flex-start
  padding 15px
  padding-top 0
  font-size 20px

.selecionado-label
  font-weight bold
  color white

.container-opcoes-paciente
  display flex
  justify-content space-between
  margin-bottom 10px
  padding 10px

.container-btn-opcoes-paciente
  display flex
  flex-direction row

.cardPaciente
  background-color #36393B

</style>
